import IconCustom from '@ant-design/icons';
import { ReactComponent as MapGis } from 'assets/images/gis-map.svg';
import { ReactComponent as OneCMS } from 'assets/images/cms.svg';
import { ReactComponent as OneCrimeIntelligence } from 'assets/images/one-crime-intelligence.svg';
import { ReactComponent as OneGis } from 'assets/images/one-gis.svg';
import { ReactComponent as OneMassNotification } from 'assets/images/one-mass-notification.svg';
import { ReactComponent as OneSOS } from 'assets/images/one-sos.svg';
import { sosWebUrl } from 'configs/variables';

export const AppMenuListOneCommand = [
  {
    key: 'gis',
    name: 'gis',
    description: 'gis_description',
    icon_path: <IconCustom component={OneGis} style={{ fontSize: 60 }} />,
    url_type: 'internal',
    direct_url: 'gis',
    query: {
      group: 'One Command',
      type: 'GIS Dashboard',
    },
  },
  // {
  //   key: 'cctv',
  //   name: 'CCTV',
  //   description: 'ระบบกล้องวงจรปิด',
  //   icon_path: <IconCustom component={OneCCTVIcon} style={{ fontSize: 60 }} />,
  //   url_type: 'external',
  //   direct_url: 'https://cctv.udoncop.com:8082/',
  //   query: {
  //     group: 'One Command',
  //     type: 'CCTV',
  //   },
  // },
  {
    key: 'checkpoint-kiosk',
    name: 'sos',
    description: 'sos_description',
    icon_path: <IconCustom component={OneSOS} style={{ fontSize: 60 }} />,
    url_type: 'external',
    direct_url: sosWebUrl,
    query: {
      group: 'One Command',
      type: 'SOS',
    },
    ignoreGlobal: true,
  },
  // {
  //   key: 'social-enable',
  //   name: 'Social Listening',
  //   description: 'ระบบรวบรวมเบาะแสจากช่องทางสื่อสังคมออนไลน์',
  //   icon_path: <IconCustom component={OneSocialEnable} style={{ fontSize: 60 }} />,
  //   url_type: 'external',
  //   direct_url: '',
  //   query: {
  //     group: 'One Command',
  //     type: 'Social Enable',
  //   },
  // },
  {
    key: 'mass-notification',
    name: 'mass_notification',
    description: 'mass_notification_description',
    icon_path: <IconCustom component={OneMassNotification} style={{ fontSize: 60 }} />,
    url_type: 'internal',
    direct_url: 'mass-notification',
    query: {
      group: 'One Command',
      type: 'Mass Notification',
    },
  },
  // {
  //   key: 'mass-notification',
  //   name: '[New] Mass Notification',
  //   description: '[New] ระบบกระจายข้อมูลเตือนภัย',
  //   icon_path: <IconCustom component={OneMassNotification} style={{ fontSize: 60 }} />,
  //   url_type: 'internal',
  //   direct_url: 'mass-noti',
  //   query: {
  //     group: 'One Command',
  //     type: 'Mass Notification',
  //   },
  // },
  {
    key: 'crime-intelligence',
    name: 'crime_intelligence_system',
    description: 'crime_intelligence_system_description',
    icon_path: <IconCustom component={OneCrimeIntelligence} style={{ fontSize: 60 }} />,
    url_type: 'internal',
    direct_url: 'crime-intelligence',
    query: {
      group: 'One Command',
      type: 'Crime Intelligence',
    },
  },
  {
    key: 'content-management-system',
    name: 'content_management_system',
    description: 'content_management_system_description',
    icon_path: <IconCustom component={OneCMS} style={{ fontSize: 60 }} />,
    url_type: 'internal',
    direct_url: 'cms',
    query: {
      group: 'One Command',
      type: 'Content Management System',
    },
  },
  // {
  //   key: 'cell-broadcast-system',
  //   name: 'Cell Broadcast System (CBS)',
  //   description: 'การแจ้งเตือนฉุกเฉิน: สำหรับการแจ้งเตือนภัยพิบัติ เช่น แผ่นดินไหว น้ำท่วม พายุ หรือประกาศจากรัฐบาล',
  //   icon_path: <IconCustom component={OneCBS} style={{ fontSize: 60 }} />,
  //   url_type: 'internal',
  //   direct_url: 'cbs',
  //   query: {
  //     group: 'One Command',
  //     type: 'Content Management System',
  //   },
  // },
  {
    key: 'patrol-detective-management',
    name: 'patrol_detective_management',
    description: 'patrol_detective_management_description',
    icon_path: <IconCustom component={MapGis} style={{ fontSize: 60 }} />,
    url_type: 'internal',
    direct_url: 'gis',
    query: {
      group: 'One Command',
      type: 'Content Management System',
    },
  },
];
